module.exports = __webpack_public_path__ + "media/images/lesson_5/sebastiao_pensamento-d2908fe736dccf52c8ec2bdc79333fac.png";